import React from 'react'
import Modal from 'react-bootstrap/Modal'

import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';

const PageModal = (props) => {
  
  const { dialogClassName, component, modalName, show, showModalName, size, title } = props

  const handleClose = () => {
    props.hide(props.modalName);
  }

  return (
    <Modal
      onHide={handleClose}
      dialogClassName={dialogClassName}
      size={size}
      animation={false}
      show={show && (modalName === showModalName)}
      keyboard={false}
      centered
    >

      <Modal.Header closeButton className="text-center">
        <Modal.Title><h3>{title}</h3></Modal.Title>
      </Modal.Header>
    
      {component}

    </Modal>

  )

}

const mapStateToProps = (state) => {
  return {
    show: state.modal.show,
    showModalName: state.modal.name
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hide: (name) => dispatch(actions.modalHide(name))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(PageModal)